import type { FaireProductEntity } from "../../entity_types/product";

export const p_5gqu9uz9v5: FaireProductEntity = {
  token: "p_5gqu9uz9v5",
  type: "product",
  name: "The Solstice Knot Studs-Gold",
  brandToken: "b_2p3pcs27",
  brandName: "Luv AJ",
  imageUrl:
    "https://cdn.faire.com/fastly/18e377ad85bf50b094a25ddb1d4bbb958fe6c23336671cc1ce24faa6bf02c482.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d10a83ecf49f09a68b1278cd5a751eced80cc71a3523fbce4bb8df0df307c652.jpeg",
    "https://cdn.faire.com/fastly/2fda62b24feeb54963fe70c0a6c599c0afeb2a6459372f1f221bdca01f396170.jpeg",
    "https://cdn.faire.com/fastly/0a3ebe77f7723fcffb4f04794e6fb34346a8b17d0dab7dadf3474abe3c2b2778.jpeg",
  ],
  priceDollars: 30,
  description:
    "Details\n\n * Pair of knotted statement earrings \n\n * Earrings are 27mm x 21mm x 5.6mm\n\n * Earrings weigh 11.35 grams per pair\n\n * 1 year warranty \n * All LuvAj.com orders are sent in Luv Aj branded gift boxes or packaging \nMaterials\n\n * Made from plated brass \n\n * Plating is waterproof and tarnish free \n * 14K plated brass and Rhodium plated silver with E-Coating \n * Plating details: 0.3 microns + e-coating for long lasting durability \n * Plated high polish 14K Gold or Rhodium for maximum shine \n * Posts are made from surgical steel so they are very hypo-allergenic for sensitive ears \n * Earrings are 100% nickel-free and cadmium-free\n",
  tags: [],
  msrpDollars: 75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:29.261Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
